<template>
  <div>
    <h6 v-if="schema.title" v-bind="schema.title.attributes">
      {{ schema.title.label }}
    </h6>

    <v-row v-if="hasSearch">
      <v-col sm="12">
        <v-btn
          color="primary"
          class="mx-2 mt-2 mb-6"
          outlined
          @click="handleShowTableSearch()"
        >
          <v-icon left color="primary">
            {{ !showTableSearch ? 'mdi-magnify' : 'mdi-file-tree' }}
          </v-icon>

          {{ !showTableSearch ? 'Pesquisar por um Artefato' : 'Voltar para visualização em árvore' }}
        </v-btn>

        <transition name="fade">
          <v-card v-if="showTableSearch">
            <v-card-title>
              <v-row>
                <v-col sm="12">
                  <h3>Lista de permissões encontradas</h3>
                </v-col>
              </v-row>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Nome do Artefato"
                placeholder="Digite aqui o Artefato a ser pesquisado"
                class="ma-4 pa-0"
                hide-details
              />

              <v-btn
                color="primary"
                class="ma-4"
                @click="getDataFromApi()"
              >
                <v-icon left color="secondary"> mdi-magnify</v-icon>
                Pesquisar
              </v-btn>
            </v-card-title>

            <v-data-table
              ref="table-flat"
              v-model="selected"
              :headers="headers"
              :items="resultNodes"
              :server-items-length="totalItems"
              :loading="loading"
              :options.sync="options"
              :item-key="keyNodeTree"
              hide-default-footer
              show-select
              checkbox-color="primary"
              @input="handleSelectRowInTable"
              @page-count="pageCount = $event"
            >
              <template v-slot:item.active="{ item }">
                <v-simple-checkbox
                  v-model="item.active"
                ></v-simple-checkbox>
              </template>

              <template v-slot:footer="{ props }">
                <v-data-footer
                  class="footerTable"
                  :showFirstLastPage="true"
                  :pagination="props.pagination"
                  :options.sync="options"
                  :items-per-page-options="itemsPerPageOptions"
                ></v-data-footer>
              </template>
            </v-data-table>
          </v-card>
        </transition>
      </v-col>
    </v-row>

    <transition name="fade">
      <v-treeview
        v-if="!showTableSearch"
        ref="tree"
        :active.sync="active"
        :load-children="fetchItems"
        :open.sync="open"
        :items="computedItems"
        v-model="selection"
        v-bind="schema.attributesTreeview"
        @input="updateState"
      >
        <template v-if="schema.iconPrepend" v-slot:prepend="{ item, open }">
          <div :class="['rounded-circle', typeIcons[item.type]?.background?.class]"
            :style="`background-color: ${typeIcons[item.type]?.background?.color}; padding: 6px`">
            <v-icon v-if="!item.type || (!typeIcons[item.type]?.icon && !typeIcons[item.type]?.iconClose)">
              {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
            </v-icon>

            <v-icon v-else v-bind="typeIcons[item.type]">
              {{ open ? typeIcons[item.type]?.icon : typeIcons[item.type]?.iconClose }}
            </v-icon>
          </div>
        </template>

        <template v-if="propertiesToRender.length"
          v-slot:label="{ item }"
        >
          <div v-for="(prop, index) in propertiesToRender" :key="`${item[schema.attributesData.items.key]}${prop.key}`"
            class="d-flex text-body-2"
          >
            <div class="d-flex">
              <b v-if="prop.label" class="mr-1">{{ prop.label }}:</b>
              <span>{{ item[prop.key] }}</span>
            </div>

            <span v-if="index + 1 < propertiesToRender.length"
              class="mx-2"
              :class="propertiesDivider.class"
              :style="propertiesDivider.style"
              data-test="divider-component"
            >
              {{ propertiesDivider.value }}
            </span>
          </div>
        </template>

        <template v-else
          v-slot:label="{ item }"
        >
          <div :aria-label="item.type + ': ' + item.name"
            :data-iat="item.type + ': ' + item.name"
            class="v-treeview-node__label text-body-2 d-flex isNode"
          >
            <div :aria-label="item.name"
              :data-label="item.name"
              class="d-flex"
              :style="schema.attributesData.showDirPath != false ? 'width: 60%' : ''"
            >
              <b v-if="item.type"
                class="mr-1 ml-2"
                :aria-label="item.type"
                :data-prefix="item.type"
              >
                {{ item.type }}:
              </b>
              {{ item.name }}
            </div>

            <div v-if="schema.attributesData.showDirPath != false"
              :aria-label="item.dir"
              :data-directory="item.dir"
              data-test="dir-prop-component"
            >
              {{ item[dirProp] }}
            </div>
          </div>
        </template>

        <template v-slot:append="{ item, open }">
          <div class="d-flex">
            <template v-if="!!item.recordActions">
              <v-layout data-test="record-actions-container">
                <i4proRecordActionItem
                  :item="item"
                  :lineActions="lineActions(item)"
                  :keyValue="schema.attributesData.items.key"
                  :origin="formOptions.mode"
                  :small="false"
                  @handleExecuteAction="handleExecuteAction($event)"
                  data-test="record-actions-item-container"
                />
              </v-layout>
            </template>

            <template v-if="schema.iconAppend">
              <v-icon class="ml-4">
                {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
              </v-icon>
            </template>
          </div>
        </template>
      </v-treeview>
    </transition>

    <!-- _show_itens_selected -->
    <!-- <v-col
      v-if="schema.showItemsSelected"
      class="pa-6"
      cols="12"
    >
      <h6 class="text-title-btn-large mt-0">
        Itens selecionados:
      </h6>
      <template v-if="!selection.length">
        No nodes selected.
      </template>
      <template v-else>
        <div
          v-for="node in selection"
          :key="node.id"
          class="text-body-2"
        >
          {{ node.name }}
        </div>
      </template>
      <v-divider class="pa-4"></v-divider>
      <pre>{{ selection }}</pre>
    </v-col> -->
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import { abstractField } from 'vue-form-generator';
import { incrementTreeDataWithDirectoryString, filterData } from '@/helpers/utils';
import { returnNodeDataRequest, executeServicesData, getData } from '@/helpers/page';

export default {
  mixins: [abstractField],

  components: {
    i4proRecordActionItem: () => import('@/components/partials/i4pro-record-action-item'),
  },

  data() {
    return {
      reloadRoot: false,
      active: [],
      open: [],
      selection: [],
      indeterminate: [],
      children: [],
      changes: [],
      typeIcons: {},
      keyNodeTree: this.schema.attributesData.items.key ? this.schema.attributesData.items.key : 'id',
      propertiesForChangeFilter: this.schema.attributesData.changes.propertiesForChangeFilter ? this.schema.attributesData.changes.propertiesForChangeFilter : [],
      keysData: {
        items: "items",
        selections: "selections",
        changes: "changes"
      },
      showTableSearch: false,
      selected: [],
      search: '',
      pageCount: 0,
      loading: false,
      totalItems: 0,
      options: {},
      itemsPerPageOptions: [
        { "text": "8", "value": 8 },
        { "text": "16", "value": 16 },
        { "text": "32", "value": 32 },
        { "text": "100", "value": 100 },
        { "text": "Todos", "value": -1 }
      ],
      headers: [
        { text: 'Nome do Artefato', align: 'start', value: 'name' },
        { text: 'Tipo', value: 'type' },
        { text: 'Caminho até o Artefato', value: 'dir' }
      ],
      resultNodes: [],
      initialItemsState: [],
    }
  },

  created() {
    this.typeIcons = structuredClone(this.schema.typeIcons ?? {});

    // Caso seja necessário usar modelo de dados com nomenclaturas diferentes
    //  o componente realiza um merge para usar o nome da propriedade dinâmicamente em todo código,
    //    através do this.keysData.
    if (this.schema.attributesData.alternativeNames) {
      _.merge(this.keysData, this.schema.attributesData.alternativeNames);
    };

    // Se o retorno da API for uma string quer dizer que é um JSON, é necessário converter
    if (typeof this.model[this.keysData.items] === 'string') {
      this.model[this.keysData.items] = JSON.parse(this.model[this.keysData.items]);
    }

    // Atribui os valores iniciais após ser carregado pelo loadPage / loadMode
    let items = this.model[this.keysData.items]

    items.forEach((item, i) => {
      this.$set(this.children, i, item.children);
    });

    // TODO revisar o sort no created!
    // tem algum problema de tempo de execução com o computedItems
    // if (this.schema.attributesData.sortByChildren) this.sortItemsByChildren(items, this.schema.attributesData.sortByChildren)
    // if (this.schema.attributesData.sortByType) this.sortItemsByType(items, this.schema.attributesData.sortByType)

    // Se o retorno for uma string quer dizer que é um JSON, é necessário converter
    // Adicionando Selections vindos de um JSON
    if (typeof this.model[this.keysData.selections] === 'string') {
      this.model[this.keysData.selections] = JSON.parse(this.model[this.keysData.selections]);
    }

    // Caso não seja informado o array de selections na model inicial, é necessário criar um array vazio.
    if (!this.model[this.keysData.selections]) {
      this.model[this.keysData.selections] = [];
    }

    this.model[this.keysData.selections].forEach(p => {
      this.selection.push({ ...p, id: p[this.keyNodeTree] });
    });

    // Caso não seja informado o array de changes na model inicial, é necessário criar um array vazio.
    if (!this.model[this.keysData.changes]) {
      this.model[this.keysData.changes] = [];
    }

      // Caso não seja informado o array de indeterminates na model inicial, é necessário criar um array vazio.
      if (!this.model['indeterminate']) {
      this.model['indeterminate'] = [];
    };

    // Adiciona os itens indeterminados vindos do backend ao array "indeterminate"
    this.model['indeterminate'].forEach(nodeIndeterminate => {
      this.indeterminate.push(nodeIndeterminate[this.keyNodeTree]);
    });

    // Atualiza a Model com as Changes iniciais
    let newModel = structuredClone(this.model);
    newModel[this.keysData.changes] = this.changes;

    this.setInitialItemsState(
      newModel[this.keysData.items],
      newModel[this.keysData.selections],
      newModel.indeterminate
    );

    this.updateModel(newModel);
  },



  mounted() {
    this.options.itemsPerPage = this.itemsPerPageOptions[0].value;
    this.updateIndeterminateNodes();
  },

  computed: {
    items() {
      let newItems = [], itemsModel = [];
      if (this.model[this.keysData.items]) {
        itemsModel = this.model[this.keysData.items]

        if (typeof itemsModel === 'string') {
          itemsModel = JSON.parse(itemsModel);
        }

        itemsModel.forEach((node, index) => {
          newItems.push(
            {
              ...node,
              id: node[this.keyNodeTree],
              children: Array.isArray(node.children) ? this.children[index] : null
            }
          );
        });
      }

      return newItems;
    },

    computedItems() {
      return incrementTreeDataWithDirectoryString(this.items);
    },

    hasSearch() {
      if (!this.schema) return;

      return ('searchNode' in this.schema)
    },

    recordActionsModel() {
      return this.schema.recordActionsModel || [];
    },

    propertiesToRender() {
      if (!this.schema || !this.schema.attributesData || !this.schema.attributesData.items) return [];
      return this.schema.attributesData.items.properties || [];
    },

    propertiesDivider() {
      const divider = {
        class: "mx-2",
        value: "|"
      }

      if (!this.schema || !this.schema.attributesData || !this.schema.attributesData.items) return divider;
      return this.schema.attributesData.items.divider || divider;
    },

    dirProp() {
      if (this.schema && this.schema.attributesData && this.schema.attributesData.alternativeDirProp) {
        return this.schema.attributesData.alternativeDirProp;
      }

      return 'dir';
    }
  },

  watch: {
    options: {
      handler () {
        this.getDataFromApi()
      },
      deep: true,
    },
  },

  methods: {
    sortItemsByType(items, sortType) {
      if (!items) return;

      // sortType = -1 => nome do tipo z - a
      // sortType = 0 => desligado
      // sortType = 1 => nome do tipo a - z

      items.sort((a, b) => {
        if (!a.type && !b.type) return 0;

        if (a.type && b.type) {
          return a.type.localeCompare(b.type);
        } else if (a.type) {
          return -1 * sortType;
        } else if (b.type) {
          return 1 * sortType;
        } else {
          return 0;
        }
      });
    },

    sortItemsByChildren(items, sortType) {
      if (!items) return;

      // sortType = -1 => sem filhos primeiro
      // sortType = 0 => desligado
      // sortType = 1 => com filhos primeiro

      items.sort((a, b) => {
        if (!a.children && !b.children) return 0;

        if (Array.isArray(a.children) && !Array.isArray(b.children)) {
          return -1 * sortType;
        } else if (!Array.isArray(a.children) && Array.isArray(b.children)) {
          return 1 * sortType;
        } else {
          return 0;
        }
      });
    },

    getFilterAndDefaultFilter () {
      // Recupera defaultFilter baseadas nas telas pai
      const state = this.$store.state.page;
      const page = this.formOptions.page;
      let parent = state.parents[page];

      const { filter, defaultFilter } = getData(state, { page, mode: this.formOptions.mode, filter: {}, parent });

      return { page, filter, defaultFilter };
    },

    async fetchItems(item, loadRoot=false) {
      const { page, filter, defaultFilter } = this.getFilterAndDefaultFilter();

      const { typeRequest, bodyRequest } = returnNodeDataRequest(
        { schema: this.schema },
        { form: item, filter, defaultFilter, page, isRedirect: false }
      );

      const data = await this.getDataServices(typeRequest, bodyRequest);

      let dataItems = []
      // Se o retorno da API for uma string quer dizer que é um JSON, é necessário converter
      if (typeof data.values[0][this.keysData.items] === 'string') {
        dataItems = JSON.parse(data.values[0][this.keysData.items]);
      } else {
        dataItems = data.values[0][this.keysData.items] || [];
      }

      if (this.schema.attributesData.sortByChildren) this.sortItemsByChildren(dataItems, this.schema.attributesData.sortByChildren)
      if (this.schema.attributesData.sortByType) this.sortItemsByType(dataItems, this.schema.attributesData.sortByType)

      let dataPermissions = []
      // Se o retorno da API for uma string quer dizer que é um JSON, é necessário converter
      if (typeof data.values[0][this.keysData.selections] === 'string') {
        dataPermissions = JSON.parse(data.values[0][this.keysData.selections]);
      } else {
        dataPermissions = data.values[0][this.keysData.selections] || [];
      }

      let dataIndeterminate = []
      // Se o retorno da API for uma string quer dizer que é um JSON, é necessário converter
      if (typeof data.values[0]['indeterminate'] === 'string') {
        dataIndeterminate = JSON.parse(data.values[0]['indeterminate']);
      } else {
        dataIndeterminate = data.values[0]['indeterminate'] || [];
      }

      let rootItems = [];
      // Adiciona a propriedade "ID" obrigatórias para o treeview conforme a key especificado via JSON
      if (!Object.keys(item).length && loadRoot) {
        this.reloadRoot = true;
        rootItems = dataItems.map(i => ({ ...i, id: i[this.keyNodeTree] }));
        rootItems.forEach((item, i) => {
          this.$set(this.children, i, []);
        });
      } else {
        this.reloadRoot = false;
        dataItems.forEach(i => {
          item.children.push({ ...i, id: i[this.keyNodeTree] })
        });
      }

      // Adiciona todos os novos itens indeterminados
      dataIndeterminate.forEach((newIndeterminates) => {
        this.indeterminate.push(newIndeterminates[this.keyNodeTree]);
      });

      // Para uma melhor reatividade, combinando nextTick com this.$set e splice, a listagem de itens selecionados é atualizado.
      this.$nextTick(() => {
        dataPermissions.forEach((newPermissions) => {
          let indexContainItem = this.selection.findIndex(p => p[this.keyNodeTree] === newPermissions[this.keyNodeTree]);
          if (indexContainItem !== -1) {
            this.selection.splice(indexContainItem, 1, { ...newPermissions, id: newPermissions[this.keyNodeTree] });
          } else {
            // this.selection.push({ ...newPermissions, id: newPermissions[this.keyNodeTree] });
            this.$set(this.selection, this.selection.length, { ...newPermissions, id: newPermissions[this.keyNodeTree] });
          }
        });

        // Atualiza a model com os novos CHILDRENS e ITENS SELECIONADOS (retornando parcial em [data], concatenando a mesma)
        let newModel = structuredClone(this.model);
        newModel[this.keysData.items] = !loadRoot ? this.items : rootItems;
        newModel[this.keysData.selections] = newModel[this.keysData.selections].concat(dataPermissions);

        this.updateIndeterminateNodes();

        this.updateModel(newModel);
      });

      this.setInitialItemsState(
        dataItems,
        dataPermissions,
        dataIndeterminate
      );

      return dataItems;
    },

    async getDataServices(typeRequest, bodyRequest) {
      const { data } = await executeServicesData(typeRequest, bodyRequest);

      return data;
    },

    updateGlobalState(resetChange=false) {
      let newModel = structuredClone(this.model);
      newModel[this.keysData.changes] = !resetChange ? this.changes : [];
      newModel[this.keysData.selections] = this.selection;

      this.updateStoreSelectedItems();
      this.updateModel(newModel);
    },

    updateStoreSelectedItems() {
      this.$store.dispatch('page/updateSelectedItems', { selectedItems: this.changes, keyValue: this.schema.model });
    },

    updateModel(newModel) {
      this.$store.commit('page/updateModel', { page: this.formOptions.page, mode: this.formOptions.mode, model: newModel, setSessionStorage: false });
    },

    updateIndeterminateNodes() {
      let nodes = Object.values(this.$refs.tree.nodes);

      if (!this.indeterminate.length) {
        return
      }

      for (const indeterminateNodeId of this.indeterminate) {
        const index = nodes.findIndex(node => node.item[this.keyNodeTree] === indeterminateNodeId);
        if (index !== -1) {
          nodes[index].isIndeterminate = true;
        }
      }
    },

    updateState() {
      const allNodes = Object.values(this.$refs.tree.nodes)

      const nodesWithoutChildren = allNodes.filter(node => {
        if (!node.parent) {
          return true
        }

        const foundParent = allNodes.find(n => n.item[this.keyNodeTree] === node.parent)
        if (foundParent) {
          if (!node.isSelected && !foundParent.isSelected && !foundParent.isIndeterminate) {
            return false
          }

          if (foundParent.isSelected && !foundParent.isIndeterminate) {
            return false
          }
        }

        return true
      })

      const mappedNodes = nodesWithoutChildren.map(node => {
        let nodeItem = {
          ...node.item
        }

        delete nodeItem.children

        return {
          ...filterData(this.propertiesForChangeFilter, {...nodeItem}),
          indeterminate: node.isIndeterminate || false,
          active: node.isIndeterminate ? true : node.isSelected
        }
      })

      let nodesWithChanges = mappedNodes
      if (this.schema.attributesData.sendOnlyChangedItems && this.initialItemsState.length) {
        nodesWithChanges = _.differenceWith(mappedNodes, this.initialItemsState, (a, b) => {
          return a[this.keyNodeTree] === b[this.keyNodeTree] && a.active === b.active && a.indeterminate === b.indeterminate;
        });
      }

      this.changes = [
        ...nodesWithChanges
      ]

      this.updateGlobalState();
    },

    setInitialItemsState(items, selections, indeterminates) {
      this.initialItemsState = [
        ...this.initialItemsState,
        ...items.map(item => {
          const isActive = selections.some(selection => selection[this.keyNodeTree] === item[this.keyNodeTree]);
          const isIndeterminate = indeterminates.some(indeterminate => indeterminate[this.keyNodeTree] === item[this.keyNodeTree]);
          return {
            id: item[this.keyNodeTree],
            [this.keyNodeTree]: item[this.keyNodeTree],
            name: item.name,
            active: isIndeterminate ? true : isActive,
            indeterminate: isIndeterminate
          }
        }),
      ]
    },

    handleShowTableSearch() {
      this.showTableSearch = !this.showTableSearch;
      this.changes = [];
      this.search = "";
      this.resultNodes = [];
      this.updateGlobalState(true);
      if (!this.showTableSearch) {
        this.reloadRoot = true;
        this.open = [];
        this.selection = [];
        this.fetchItems({}, true);
      }
    },

    async getDataFromApi() {
      if (!this.search) return;
      this.loading = true;
      const data = await this.fetchItemsTableSearch();
      this.loading = false;

      if (data.values && data.values.length > 0) {
        this.resultNodes = data.values;
        this.totalItems = data.values[0].totalRows;

        let dataPermissions = data.values.filter( item => item.active === true );

        this.$nextTick(() => {
          if (dataPermissions.length) {
            dataPermissions.forEach((newPermissions) => {
              let indexContainItem = this.selected.findIndex(p => p[this.keyNodeTree] === newPermissions[this.keyNodeTree]);
              if (indexContainItem !== -1) {
                this.selected.splice(indexContainItem, 1, { ...newPermissions, id: newPermissions[this.keyNodeTree] });
              } else {
                this.$set(this.selected, this.selected.length, { ...newPermissions, id: newPermissions[this.keyNodeTree] });
              }
            });
          } else {
            this.selected = []
          }
        })
      } else {
        this.resultNodes = data.values;
        this.totalItems = 0;
      }
    },

    async fetchItemsTableSearch() {
      // Instância os dados para carregar a lista páginada
      const { sortBy, sortDesc, itemsPerPage } = this.options;
      const pageNumber = this.options.page;
			const offset = (pageNumber - 1) * itemsPerPage;

      const bodyRequestSearchNode = {
        model: { search: this.search },
        filter: { limit: itemsPerPage, offset, sortBy, sortDesc }
      };

      // Executa a pesquisa
      const { page, defaultFilter } = this.getFilterAndDefaultFilter();
      const { typeRequest, bodyRequest } = returnNodeDataRequest(
        { schema: this.schema.searchNode },
        { form: bodyRequestSearchNode.model, filter: bodyRequestSearchNode.filter, defaultFilter, page, isRedirect: false }
      );

      const data = await this.getDataServices(typeRequest, bodyRequest);

      return data;
    },

    handleSelectRowInTable(items) {
      this.selected = items;
    },

    lineActions(item) {
      if (item.recordActions && typeof item.recordActions === 'boolean' && this.recordActionsModel && this.recordActionsModel.length) {
        return this.recordActionsModel;
      }

      if (item.recordActions && this.recordActionsModel && this.recordActionsModel.length) {
        return this.recordActionsModel.filter(action => item.recordActions.includes(action.name));
      }

      return []
    },

    handleExecuteAction(event) {
      const { action, origin, model } = event
      this.executeAction(action, origin, model)
    },

    executeAction(action, origin, model) {
      if (action.confirmMessage) {
        this.confirmDialog(action, origin, model);
      } else {
        this.action(action, origin, model);
      }
    },

    async action(action, origin, model) {
      this.$store.dispatch('page/executeAction', {
        page: this.formOptions.page,
        mode: this.formOptions.mode,
        origin,
        action,
        model
      });
    },

    confirmDialog(action, origin, model) {
      const {
        title,
        text,
        html,
        icon,
        showCancelButton,
        confirmButtonText,
        cancelButtonText,
        reverseButtons,
        confirmButtonClass,
        cancelButtonClass
      } = action.confirmMessage;

      let defaultClassConfirm = confirmButtonClass || 'primary';
      let defaultClassCancel = cancelButtonClass || 'error';

      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: `v-btn v-size--default ${defaultClassConfirm}`,
          cancelButton: `v-btn v-size--default error ${defaultClassCancel}`
        },
        buttonsStyling: false
      });

      swalWithBootstrapButtons
        .fire({
          title,
          text,
          html,
          icon,
          showCancelButton,
          confirmButtonText,
          cancelButtonText,
          reverseButtons
        })
        .then(result => {
          if (result.value) this.action(action, origin, model);
        });
    },
  }
}
</script>

<style scoped lang="scss">
.fade-enter-active {
  transition: opacity .6s;
}
.fade-enter, .fade-leave-to, .fade-leave-active /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
